import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { RESULTS_PER_PAGE } from 'settings';
import getOffset from '../selector/getOffset';
import fetchSearchResultsOperation from './fetchSearchResultsOperation';

const fetchResultsForPreviousPageOperation =
  () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const offset = getOffset(store);
    const offsetPageNr = Math.round(offset / RESULTS_PER_PAGE) + 1;
    dispatch(fetchSearchResultsOperation(Math.max(offsetPageNr - 1, 1)));
  };

export default fetchResultsForPreviousPageOperation;
